import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, normalizeClass as _normalizeClass, Fragment as _Fragment, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "d-flex flex-column pt-2" }
const _hoisted_2 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_3 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_4 = {
  class: "step-wrapper",
  style: {"gap":"1.5rem"}
}
const _hoisted_5 = { class: "lead w-100 mb-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-file-excel" }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "p-1 d-flex align-items-center w-100 flex-wrap justify-content-center"
}
const _hoisted_8 = ["alt", "src"]
const _hoisted_9 = { class: "text-bold ml-2 flex-1" }
const _hoisted_10 = { class: "ml-2" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  class: "video-overlay"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("svg", null, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-play" })
], -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  alt: "Youtube thumbnail",
  class: "video-image"
}
const _hoisted_16 = { class: "step-wrapper flex-column" }
const _hoisted_17 = {
  key: 0,
  class: "mb-2 p-1 d-flex align-items-center w-100 flex-wrap justify-content-center"
}
const _hoisted_18 = ["alt", "src"]
const _hoisted_19 = { class: "text-bold flex-1" }
const _hoisted_20 = { class: "ml-2" }
const _hoisted_21 = {
  key: 0,
  class: "text-success ml-2"
}
const _hoisted_22 = {
  key: 1,
  class: "text-danger ml-2"
}
const _hoisted_23 = { class: "ml-2" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = {
  key: 0,
  class: "p-error"
}
const _hoisted_27 = {
  key: 1,
  class: "p-error"
}
const _hoisted_28 = { class: "step-wrapper p-2 p-lg-3" }
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = { class: "d-flex align-items-center justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Message = _resolveComponent("Message")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Dialog, {
      visible: _ctx.isVisible,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isVisible) = $event)),
      breakpoints: {
				'2000px': '50vw',
				'1600px': '60vw',
				'1200px': '70vw',
				'992px': '75vw',
				'768px': '80vw',
				'576px': '90vw',
			},
      class: "p-dialog-secondary advisor-upload-modal",
      closable: _ctx.canClose,
      draggable: false,
      modal: true,
      style: { width: '40vw' },
      onHide: _cache[9] || (_cache[9] = ($event: any) => (_ctx.hideModal()))
    }, _createSlots({
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.vm.introText), 1),
          _createElementVNode("div", {
            class: "upload-container",
            style: _normalizeStyle(_ctx.isSmallScreen ? 'order:2' : 'order:1')
          }, [
            _createVNode(_component_FileUpload, {
              ref: "fileUploader",
              accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
              auto: true,
              "custom-upload": true,
              "invalid-file-type-message": _ctx.$t('digitalAdvisor.dialog.msgInvalidFileType'),
              "max-file-size": _ctx.sizeLimit,
              mode: "advanced",
              multiple: false,
              name: "advisorUpload",
              "show-cancel-button": false,
              "show-upload-button": false,
              onUploader: _ctx.onFileSelected
            }, {
              header: _withCtx(() => []),
              empty: _withCtx(() => [
                _hoisted_6,
                _createVNode(_component_i18n_t, {
                  class: "mb-0",
                  keypath: "digitalAdvisor.dialog.lblDragFile",
                  scope: "global",
                  tag: "p"
                }, {
                  action: _withCtx(() => [
                    _createVNode(_component_Button, {
                      class: "p-button-link text-primary p-0",
                      label: _ctx.$t('common.chooseFile'),
                      onClick: _ctx.onFileUpload
                    }, null, 8, ["label", "onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["invalid-file-type-message", "max-file-size", "onUploader"]),
            (_ctx.selectedFile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", null, [
                    (_ctx.selectedFile?.objectURL)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          alt: _ctx.selectedFile?.name,
                          class: "",
                          height: "50",
                          role: "presentation",
                          src: _ctx.selectedFile?.objectURL,
                          width: "100"
                        }, null, 8, _hoisted_8))
                      : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 1,
                          class: "text-primary",
                          icon: ['far', 'file'],
                          size: "1x"
                        }))
                  ]),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.selectedFile?.name), 1),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.formatSize(_ctx.selectedFile?.size)), 1),
                  _createVNode(_component_Button, {
                    class: "p-button-text p-button-danger p-button-rounded ml-2",
                    icon: "pi pi-trash",
                    label: _ctx.isSmallScreen ? _ctx.$t('common.remove') : '',
                    title: _ctx.$t('common.remove'),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onFileRemoved(_ctx.selectedFile)))
                  }, null, 8, ["label", "title"])
                ]))
              : _createCommentVNode("", true)
          ], 4),
          (_ctx.hasVideo)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "video-container",
                style: _normalizeStyle(_ctx.isSmallScreen ? 'order:1' : 'order:2')
              }, [
                (_ctx.showVideo)
                  ? (_openBlock(), _createElementBlock("iframe", {
                      key: 0,
                      allowfullscreen: "",
                      height: "100%",
                      src: `https://www.youtube.com/embed/${_ctx.vm.youtubeId}?autoplay=1`,
                      type: "video/mp4",
                      width: "100%"
                    }, null, 8, _hoisted_11))
                  : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("button", {
                        class: "play-button",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onPlayVideoClick && _ctx.onPlayVideoClick(...args)))
                      }, _hoisted_14),
                      _withDirectives(_createElementVNode("img", _hoisted_15, null, 512), [
                        [_directive_lazy, `https://img.youtube.com/vi/${_ctx.vm.youtubeId}/maxresdefault.jpg`]
                      ])
                    ]))
              ], 4))
            : _createCommentVNode("", true),
          (!_ctx.uploadSuccess && _ctx.selectedFile && !_ctx.isBusy)
            ? (_openBlock(), _createBlock(_component_Message, {
                key: 1,
                class: "my-0 w-100",
                closable: false,
                severity: "error",
                style: {"order":"3"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("digitalAdvisor.dialog.msgUploadError")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, _ctx.currentStep === 1]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_16, [
          (_ctx.selectedFile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", null, [
                  (_ctx.selectedFile?.objectURL)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        alt: _ctx.selectedFile?.name,
                        class: "",
                        height: "50",
                        role: "presentation",
                        src: _ctx.selectedFile?.objectURL,
                        width: "100"
                      }, null, 8, _hoisted_18))
                    : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 1,
                        class: "text-primary",
                        icon: ['far', 'file'],
                        size: "1x"
                      }))
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.selectedFile?.name), 1),
                  (_ctx.uploadSuccess)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t("digitalAdvisor.dialog.lblUploadSuccess")), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$t("digitalAdvisor.dialog.lblUploadFailed")), 1))
                ]),
                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.formatSize(_ctx.selectedFile?.size)), 1),
                _createVNode(_component_Button, {
                  class: "p-button-text p-button-danger p-button-rounded ml-2",
                  icon: "pi pi-trash",
                  label: _ctx.isSmallScreen ? _ctx.$t('common.remove') : '',
                  title: _ctx.$t('common.remove'),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onFileRemoved(_ctx.selectedFile)))
                }, null, 8, ["label", "title"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.uploadSuccess)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("p", {
                  class: "text-preline",
                  innerHTML: _ctx.vm.emailIntroText
                }, null, 8, _hoisted_24),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("label", {
                    class: _normalizeClass({ required: _ctx.v$['usageUploadForm'].email?.required })
                  }, _toDisplayString(_ctx.$t("common.forms.lblEmail")), 3),
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.v$['usageUploadForm'].email.$model,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$['usageUploadForm'].email.$model) = $event)),
                    class: _normalizeClass({ 'p-invalid': _ctx.shouldShowError(_ctx.v$['usageUploadForm'].email) }),
                    type: "email"
                  }, null, 8, ["modelValue", "class"]),
                  (
								_ctx.shouldShowError(_ctx.v$['usageUploadForm'].email) && !_ctx.v$['usageUploadForm'].email.$model
							)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_26, _toDisplayString(_ctx.v$["usageUploadForm"].email?.required?.$message), 1))
                    : (
								_ctx.shouldShowError(_ctx.v$['usageUploadForm'].email) && _ctx.v$['usageUploadForm'].email.$model
							)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_27, _toDisplayString(_ctx.v$["usageUploadForm"].email.email?.$message), 1))
                      : _createCommentVNode("", true)
                ])
              ], 64))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, _ctx.currentStep === 2]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_28, [
          _createElementVNode("p", {
            class: "preserve-html lead w-100 mb-0",
            innerHTML: _ctx.$t('digitalAdvisor.dialog.thankyou')
          }, null, 8, _hoisted_29)
        ], 512), [
          [_vShow, _ctx.currentStep === 4]
        ])
      ]),
      _: 2
    }, [
      (_ctx.canClose)
        ? {
            name: "header",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                (_ctx.vm.title && _ctx.currentStep !== 4)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(_ctx.vm.title), 1))
                  : _createCommentVNode("", true),
                (_ctx.currentStep === 4)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString(_ctx.$t('digitalAdvisor.dialog.thankyouTitle')), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            key: "0"
          }
        : undefined,
      (_ctx.canClose)
        ? {
            name: "footer",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_30, [
                (_ctx.currentStep === 4)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: "p-button-success p-button-arrow p-button-sm",
                      label: _ctx.$t('common.close'),
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hideModal()))
                    }, null, 8, ["label"]))
                  : _createCommentVNode("", true),
                (_ctx.currentStep !== 4)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      class: "p-button-text p-button-plain",
                      label: _ctx.$t('common.cancel'),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.hideModal()))
                    }, null, 8, ["label"]))
                  : _createCommentVNode("", true),
                (!_ctx.hasPollingError && _ctx.currentStep !== 4)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 2,
                      class: "p-button-success p-button-arrow p-button-sm",
                      disabled: !_ctx.canSubmit,
                      label: _ctx.$t('common.send'),
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onSubmit()))
                    }, null, 8, ["disabled", "label"]))
                  : (_ctx.currentStep !== 4)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 3,
                        class: "p-button-primary p-button-arrow p-button-sm",
                        disabled: !_ctx.canSubmit,
                        label: _ctx.$t('common.tryAgain'),
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onReset()))
                      }, null, 8, ["disabled", "label"]))
                    : _createCommentVNode("", true)
              ])
            ]),
            key: "1"
          }
        : undefined
    ]), 1032, ["visible", "closable"])
  ]))
}